/** @param {number} value @param {number} [decimals=4] */
export function round(value, decimals = 4) {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

/**
 * @param {{ left: number; top: number; width: number; height: number }} screenRect
 * @param {DOMRect} canvasRect
 */
export function screenRectToPdfAnchor(
  screenRect,
  canvasRect,
  pdfPageWidthPt,
  pdfPageHeightPt,
  pageNumber,
  signerId
) {
  const scaleX = pdfPageWidthPt / canvasRect.width;
  const scaleY = pdfPageHeightPt / canvasRect.height;

  const x = round(screenRect.left * scaleX);
  const y = round(screenRect.top * scaleY);
  const width = round(screenRect.width * scaleX);
  const height = round(screenRect.height * scaleY);

  const clamped = clampPdfRect(
    { x, y, width, height },
    pdfPageWidthPt,
    pdfPageHeightPt
  );

  return {
    signer_id: signerId,
    page_number: pageNumber,
    x: clamped.x,
    y: clamped.y,
    width: clamped.width,
    height: clamped.height,
    page_relative: true,
    pdf_page_width_pt: pdfPageWidthPt,
    pdf_page_height_pt: pdfPageHeightPt,
  };
}

/**
 * @param {{ x: number; y: number; width: number; height: number }} anchor
 * @param {DOMRect} canvasRect
 */
export function pdfAnchorToScreenRect(anchor, canvasRect, pdfPageWidthPt, pdfPageHeightPt) {
  const scaleX = canvasRect.width / pdfPageWidthPt;
  const scaleY = canvasRect.height / pdfPageHeightPt;

  return {
    left: anchor.x * scaleX,
    top: anchor.y * scaleY,
    width: anchor.width * scaleX,
    height: anchor.height * scaleY,
  };
}

/** @param {{ x: number; y: number; width: number; height: number }} rect */
export function clampPdfRect(rect, pageWidthPt, pageHeightPt, minWidth = 50, minHeight = 20) {
  let width = Math.max(minWidth, rect.width);
  let height = Math.max(minHeight, rect.height);
  let x = rect.x;
  let y = rect.y;

  if (x < 0) x = 0;
  if (y < 0) y = 0;
  if (x + width > pageWidthPt) {
    x = Math.max(0, pageWidthPt - width);
  }
  if (y + height > pageHeightPt) {
    y = Math.max(0, pageHeightPt - height);
  }

  width = Math.min(width, pageWidthPt - x);
  height = Math.min(height, pageHeightPt - y);

  return { x: round(x), y: round(y), width: round(width), height: round(height) };
}

/** Default placement for a new field (PDF points). */
export function defaultPdfAnchor(pageNumber, signerId, pdfPageWidthPt, pdfPageHeightPt) {
  const width = 220;
  const height = 40;
  const x = 72;
  const y = Math.max(72, (pdfPageHeightPt - height) / 2);

  return {
    signer_id: signerId,
    page_number: pageNumber,
    x,
    y,
    width,
    height,
    page_relative: true,
    pdf_page_width_pt: pdfPageWidthPt,
    pdf_page_height_pt: pdfPageHeightPt,
  };
}
